<template>
    <div>
        <button
            class="btn btn-md is-ghost is-danger"
            @click="$modal.show('delete-delivery-address-relation')"
        >
            Frikoppla adress från leveransprojekt
        </button>
        <adaptive-form-modal
            name="delete-delivery-address-relation"
            primary-button-text="Ta bort"
            primary-button-class="is-danger"
            title="Ta bort adress"
            :redirect-to="route('admin.delivery-projects.addresses.index', deliveryProject)"
            method="delete"
            :action="route('api.delivery-projects.addresses.destroy', [deliveryProject, address.id])"
        >
            <p>
                Vill du verkligen ta bort adressen från leveransprojektet?<br>
                Om du frikopplar en adress så kommer checklistor och dess innehåll att raderas.
            </p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            address: {
                type: Object,
                required: true,
            },
            deliveryProject: {
                type: Object,
                required: true,
            },
        },
    };
</script>
